import { IDocumentShareAttachment } from '../../models/DocumentShare';

/** Formats a backend LocalDate string (e.g. "2027-06-30") for display. */
export function formatReviewDate(d?: string): string {
    if (!d) return '';
    // Anchor a date-only value to local midnight so it doesn't shift across time zones.
    const iso = /^\d{4}-\d{2}-\d{2}$/.test(d) ? `${d}T00:00:00` : d;
    const date = new Date(iso);
    return Number.isNaN(date.getTime()) ? d : date.toLocaleDateString();
}

const IMAGE_EXT = /\.(png|jpe?g|gif|webp|bmp|svg)$/i;

export function isImage(att: IDocumentShareAttachment): boolean {
    return (att.contentType ?? '').startsWith('image/') || IMAGE_EXT.test(att.fileName ?? '');
}

export function isPdf(att: IDocumentShareAttachment): boolean {
    return (att.contentType ?? '') === 'application/pdf' || /\.pdf$/i.test(att.fileName ?? '');
}
